import { Color, FontFamilies } from '@persona-id/design-tokens';
import {
  FONT_SIZES,
  FONT_WEIGHTS,
  LINE_HEIGHTS,
  MEDIA_QUERIES,
  SPACINGS,
} from 'shared/styles/variables';
import { createGlobalStyle } from 'styled-components';

import FlowType from 'verify/lib/interfaces/FlowType';

export default createGlobalStyle<{ flowType?: FlowType }>`
  body {
    height: 100%;
    width: 100%;
    font-size: ${FONT_SIZES.p};
    line-height: ${LINE_HEIGHTS.p};
    color: ${Color.CoreSlate500};
    -webkit-font-smoothing: antialiased;
    font-family: ${FontFamilies.Primary};

    /* For iOS scrolling */
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    @media ${MEDIA_QUERIES.isMobile} {
      overflow: hidden;
    }

    @media ${MEDIA_QUERIES.isNotMobile} {
      background-color: ${({ flowType }) => (flowType === FlowType.Inline ? 'unset' : '#505060')};
    }
  }

  input, textarea, select {
    /* iOS Safari automatically sets opacity 0.4 */
    opacity: unset;
  }

  a {
    color: ${({ theme }) => theme.colorLink};
    font-size: inherit;
    line-height: inherit;
    text-decoration-line: ${({ theme }) => theme.textDecorationLineLink};

    /* Only show outline when focused via keyboard */
    &:focus-visible {
      outline: ${({ theme }) => theme.colorLink} auto 1px;
      outline-offset: 2px;
    }
  }

  /* h2 and h3 TEMPORARILY used via Markdown in inquiry flows */
  h2 {
    font-size: ${FONT_SIZES.h2};
    line-height: ${LINE_HEIGHTS.h2};
    font-weight: ${FONT_WEIGHTS.semiBold};
    margin-bottom: ${SPACINGS.base}px;
  }

  h3 {
    font-size: ${FONT_SIZES.h3};
    line-height: ${LINE_HEIGHTS.h3};
    font-weight: ${FONT_WEIGHTS.semiBold};
  }

  small {
    font-size: ${FONT_SIZES.small};
    line-height: ${LINE_HEIGHTS.small};

    a {
      font-size: ${FONT_SIZES.small};
      line-height: ${LINE_HEIGHTS.small};
    }
  }

  section {
    margin-bottom: ${SPACINGS.base * 2}px;
  }

  /**
   * Temporary CSS file until we commit to a grid format.
   */
  .row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -${SPACINGS.base * 2}px;
    margin-left: -${SPACINGS.base * 2}px;
  }

  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: ${SPACINGS.base * 2}px;
    padding-left: ${SPACINGS.base * 2}px;
  }

  @media (min-width: 576px) {
    .col-sm-1 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 8.333333%;
      flex: 0 0 8.333333%;
      max-width: 8.333333%;
    }
    .col-sm-2 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 16.666667%;
      flex: 0 0 16.666667%;
      max-width: 16.666667%;
    }
    .col-sm-3 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }
    .col-sm-4 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
    .col-sm-5 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 41.666667%;
      flex: 0 0 41.666667%;
      max-width: 41.666667%;
    }
    .col-sm-6 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
    .col-sm-7 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 58.333333%;
      flex: 0 0 58.333333%;
      max-width: 58.333333%;
    }
    .col-sm-8 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 66.666667%;
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
    }
    .col-sm-9 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 75%;
      flex: 0 0 75%;
      max-width: 75%;
    }
    .col-sm-10 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 83.333333%;
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
    }
    .col-sm-11 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 91.666667%;
      flex: 0 0 91.666667%;
      max-width: 91.666667%;
    }
    .col-sm-12 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;
